import type { FaireProductEntity } from "../../entity_types/product";

export const p_ba3wyxf3sr: FaireProductEntity = {
  token: "p_ba3wyxf3sr",
  type: "product",
  name: "Heart Lined Notepad",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/d915c28953507381731943102d8c992df50510e3db4b2825ae3f84d44a4b9f79.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/74506b33c5fb429216c2d98ca8b4d9144f9e2d8ff146324c76a831f2865e6a46/1558642270.png",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/c5017f647144e0a2da62278a6c19827a04bdf9268dcc4966f3672e5bbc3c29c0/1558642278.png",
    "https://cdn.faire.com/fastly/08fc1d62962290996502ff5609da234cb23c7a4344cbf5676b6ce87d705f8115.png",
    "https://cdn.faire.com/fastly/83ee41f3b2d445956549af41a75a0f598d6acdf5021c204ba544ba177cebfd97.png",
    "https://cdn.faire.com/fastly/b34d9691dceebf7f846b851c09db13909a4fcb5b8b65ce35427e8700c8d5d87f.png",
  ],
  priceDollars: 9,
  description:
    "Who doesn't love a fresh, crisp and clean new notepad?! It's such a hopeful item. Just think of all you will go through together! \n\nAt E. Frances, we want each page to bring joy to your list-making, doodling and note-taking.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:54.438Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
